export default __webpack_public_path__ + "static/media/html.974033d6.png";